// import ReactModal from 'react-modal';

const Checkout = () => {
  return (
    <>
      <></>
    </>
  );
};

export default Checkout;
